var _Circle, _Path, _Circle2, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgIconPlayers = function SvgIconPlayers(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 8,
    cy: 7,
    r: 3.25,
    stroke: "#FFD766",
    strokeWidth: 1.5
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#FFD766",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M2 18.5a6 6 0 0 1 12 0"
  })), _Circle2 || (_Circle2 = /*#__PURE__*/React.createElement(Circle, {
    cx: 15,
    cy: 6.5,
    r: 2.75,
    stroke: "#FFD766",
    strokeWidth: 1.5
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#FFD766",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M15.5 11.5a5 5 0 0 1 5 5"
  })));
};
export default SvgIconPlayers;